import moment from 'moment';

export const timeIntervalsPresets = [
  {
    text: 'Last 7 days',
    startTime: moment().subtract(7, 'days'),
    endTime: moment(),
  },
  {
    text: 'Last 14 days',
    startTime: moment().subtract(14, 'days'),
    endTime: moment(),
  },
  {
    text: 'This month',
    startTime: moment().startOf('month'),
    endTime: moment().endOf('month'),
  },
  {
    text: 'Last month',
    startTime: moment().subtract(1, 'month').startOf('month'),
    endTime: moment().subtract(1, 'month').endOf('month'),
  },
  {
    text: 'Last 6 Months',
    startTime: moment().subtract(6, 'month').startOf('month'),
    endTime: moment().subtract(1, 'month').endOf('month'),
  },
];
